import React from 'react';
import { useNavigate } from 'react-router-dom';
import { number, object, string } from 'yup';

import { useToast } from 'Component/Alerta';
import BotaoLink from 'Component/BotaoLink';
import Cabecalho from 'Component/Cabecalho';
import Form, { Botao, Campo, Selecao } from 'Component/Form';
import LayoutDefault from 'Component/Layout';
import Departamento from 'Interface/Departamentos';
import { useRecuperarUsuariosQuery } from 'Service';
import { useAdicionarDepartamentoMutation } from 'View/Service/Default/Departamentos';

const regras = object({
  usuario_id: number().nullable().optional(),
  nome: string().required('Obrigatório'),
});

const Adicionar = (): React.ReactElement => {
  const navegacao = useNavigate();
  const toast = useToast();
  const [adicionarDepartamento] = useAdicionarDepartamentoMutation();

  const { data: { usuarios } = {} } = useRecuperarUsuariosQuery({
    finder: 'listaJson',
    options: {
      status: 1,
    },
    sort: 'nome',
  });

  const enviar = async (dados: Departamento): Promise<void> => {
    try {
      await adicionarDepartamento(dados).unwrap();

      toast({ conteudo: 'Adicionado com sucesso!', tema: 'success' });

      navegacao('/departamentos');
    } catch (error) {
      toast({
        titulo: 'Erro ao adicionar',
        conteudo: 'Verifique os logs para maiores detalhes.',
        tema: 'danger',
      });
    }
  };

  return (
    <LayoutDefault>
      <Cabecalho
        titulo="Adicionando departamento"
        descricao="Preencha o formulário e clique em enviar para adicionar o departamento"
      />
      <Form onSubmit={enviar} regras={regras}>
        <div className="row justify-content-center">
          <div className="col-md-4">
            <div className="bg-white shadow-sm rounded p-4">
              <Selecao
                name="usuario_id"
                rotulo="Gerente do departamento"
                opcoes={usuarios}
              />
              <Campo name="nome" rotulo="Nome" />
              <div className="mt-5">
                <Botao>Enviar</Botao>
                <BotaoLink tema="light" to="/departamentos" className="ms-2">
                  Cancelar
                </BotaoLink>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </LayoutDefault>
  );
};

export default Adicionar;
